import React, { useEffect } from 'react'
import { Footer } from './footer';
import { Header } from './header';
import { HeaderMobile } from './../utils/header-mobile';
import { SearchForm } from './../utils/search-form';

export const Main = (components) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className='mobile_nav_class jl-has-sidebar active_mobile_nav_class'>
            <div className="options_layout_wrapper jl_clear_at jl_radius jl_none_box_styles jl_border_radiuss jl_en_day_night">
                <div className="options_layout_container full_layout_enable_front">
                    <Header />
                    {/* <HeaderMobile /> */}
                    <SearchForm />
                    <div className="mobile_menu_overlay" />
                    <div className="jl_home_bw">
                        {components.children}
                    </div>
                    <Footer/>
                </div>
            </div>
        </div>
    )
};